export interface Participant extends ParticipantData {
	id: string
	covid?: boolean
	backToWork: boolean
	participantType: number,
  quest?: boolean
}

export interface FullParticipant extends Participant, ActivityParticipantDetails{

}

export interface ParticipantData extends Address, MailingAddress{
	dateOfBirth: Date
	email: string
	ethnicity: Ethnicity
	externalId: string
	firstName: string
	gender: Gender
	lastName: string
	middleInitial: string
	phoneNumber: string
	races: Race[]
	homeless: boolean
	participantId: string
	activityParticipantId: string
}

export interface Address {
	address1: string
	address2?: string
	city: string
	state: StateIDs
	zip: string
}

export interface MailingAddress {
	mailingAddress1: string
	mailingAddress2?: string
	mailingCity: string
	mailingState: StateIDs
	mailingZip: string
	sameAsHomeAddress?: boolean
}

export interface ParticipantActivity {
	activityId: string
	activityDate: Date
	activityName: string
	addendumId: string
	partnershipId: string
	partnershipName: string
}

export interface ActivityParticipant {
	id: string
	participantId: string
	firstName: string
	middleInitial?: string
	lastName: string
	enrollmentDate?: Date
  // Removed: Outcome Actual Start Date (outcome.start_date) — no longer collected
  // outcomeActualStartDate?: Date
	status?: string
  quest?: number
}

export interface ActivityParticipantDetails extends Schooling, Employment {
	citizen: string
	familyDependent: string
	participantId: string
	veteran: string
}

interface Schooling {
	attendingSchool: string
	currentSchool?: string
	education: Education
	ell: string
	highestGrade?: number
}

interface Employment {
	beingLaidOff?: string
	betterSkills?: string
	currentlyEmployed?: string
	employmentType?: EmploymentType
	employer?: string
	higherWage?: string
	laidOff?: string
	layoffDate?: Date
	layoffEmployer?: string
	working?: string
}

export enum Race {
	ASIAN = "ASIAN",
	ISLANDER = "ISLANDER",
	INDIGENOUS = "INDIGENOUS",
	WHITE = "WHITE",
	BLACK = "BLACK",
	NA = "NA"
}

export enum Gender {
	MALE = 'MALE',
	FEMALE = 'FEMALE',
	NA = 'NA',
	TRANS_MALE = 'TRANS_MALE',
	TRANS_FEMALE = 'TRANS_FEMALE',
	NON_BINARY = 'NON_BINARY',
	OTHER = 'OTHER',
	DND = 'DND',
}

export enum Ethnicity {
	LATINO = "LATINO",
	NOT_LATINO = "NOT_LATINO",
	NA = "NA"
}

export const GENDER_MAPPER = {
	MALE: 'Male',
	FEMALE: 'Female',
	NA: 'Not Applicable',
	TRANS_MALE: 'Transgender Male',
	TRANS_FEMALE: 'Transgender Female',
	NON_BINARY: 'Non-conforming/Non-binary',
	OTHER: 'Other',
	DND: 'Did not disclose',
}

export const ETHNICITY_MAPPER = {
	LATINO: 'Latino',
	NOT_LATINO: 'Not Latino',
	NA: 'Did not disclose'
}

export enum EmploymentType {
	FULL_TIME = "FULL_TIME",
	PART_TIME = "PART_TIME"
}

export enum Education {
	NO_HIGHSCHOOL = "NO_HIGHSCHOOL",
	HIGH_SCHOOL = "HIGH_SCHOOL",
	GED = "GED",
	SOME_COLLEGE = "SOME_COLLEGE",
	VOCATIONAL = "VOCATIONAL",
	ASSOCIATE = "ASSOCIATE",
	BACHELORS = "BACHELORS",
	MASTERS = "MASTERS",
	PHD = "PHD",
	NA = "NA",
}

export enum StateIDs {
	AK,
	AL,
	AR,
	AZ,
	CA,
	CO,
	CT,
	DE,
	FL,
	GA,
	HI,
	IA,
	ID,
	IL,
	IN,
	KS,
	KY,
	LA,
	MA,
	MD,
	ME,
	MI,
	MN,
	MO,
	MS,
	MT,
	NC,
	ND,
	NE,
	NH,
	NJ,
	NM,
	NV,
	NY,
	OH,
	OK,
	OR,
	PA,
	RI,
	SC,
	SD,
	TN,
	TX,
	UT,
	VA,
	VT,
	WA,
	WI,
	WV,
	WY,
}

export const State_City_Zip_Mapper = [{
  "city": "Little Compton",
  "state": "RI",
  "zip": "02801"
}, {
  "city": "Lincoln",
  "state": "RI",
  "zip": "02802"
}, {
  "city": "Hopkinton",
  "state": "RI",
  "zip": "02804"
}, {
  "city": "Barrington",
  "state": "RI",
  "zip": "02806"
}, {
  "city": "Block Island",
  "state": "RI",
  "zip": "02807"
}, {
  "city": "Westerly",
  "state": "RI",
  "zip": "02808"
}, {
  "city": "Bristol",
  "state": "RI",
  "zip": "02809"
}, {
  "city": "Charlestown",
  "state": "RI",
  "zip": "02812"
}, {
  "city": "Charlestown",
  "state": "RI",
  "zip": "02813"
}, {
  "city": "Glocester",
  "state": "RI",
  "zip": "02814"
}, {
  "city": "Foster",
  "state": "RI",
  "zip": "02815"
}, {
  "city": "Coventry",
  "state": "RI",
  "zip": "02816"
}, {
  "city": "West Greenwich",
  "state": "RI",
  "zip": "02817"
}, {
  "city": "East Greenwich",
  "state": "RI",
  "zip": "02818"
}, {
  "city": "Exeter",
  "state": "RI",
  "zip": "02822"
}, {
  "city": "Coventry",
  "state": "RI",
  "zip": "02823"
}, {
  "city": "North Smithfield",
  "state": "RI",
  "zip": "02824"
}, {
  "city": "Foster",
  "state": "RI",
  "zip": "02825"
}, {
  "city": "Burrillville",
  "state": "RI",
  "zip": "02826"
}, {
  "city": "Coventry",
  "state": "RI",
  "zip": "02827"
}, {
  "city": "Smithfield",
  "state": "RI",
  "zip": "02828"
}, {
  "city": "Glocester",
  "state": "RI",
  "zip": "02829"
}, {
  "city": "Burrillville",
  "state": "RI",
  "zip": "02830"
}, {
  "city": "Cranston",
  "state": "RI",
  "zip": "02831"
}, {
  "city": "Hopkinton",
  "state": "RI",
  "zip": "02832"
}, {
  "city": "Hopkinton",
  "state": "RI",
  "zip": "02833"
}, {
  "city": "Jamestown",
  "state": "RI",
  "zip": "02835"
}, {
  "city": "Richmond",
  "state": "RI",
  "zip": "02836"
}, {
  "city": "Little Compton",
  "state": "RI",
  "zip": "02837"
}, {
  "city": "Lincoln",
  "state": "RI",
  "zip": "02838"
}, {
  "city": "Burrillville",
  "state": "RI",
  "zip": "02839"
}, {
  "city": "Newport",
  "state": "RI",
  "zip": "02840"
}, {
  "city": "Newport",
  "state": "RI",
  "zip": "02841"
}, {
  "city": "Middletown",
  "state": "RI",
  "zip": "02842"
}, {
  "city": "North Kingstown",
  "state": "RI",
  "zip": "02852"
}, {
  "city": "Scituate",
  "state": "RI",
  "zip": "02857"
}, {
  "city": "Burrillville",
  "state": "RI",
  "zip": "02858"
}, {
  "city": "Burrillville",
  "state": "RI",
  "zip": "02859"
}, {
  "city": "Pawtucket",
  "state": "RI",
  "zip": "02860"
}, {
  "city": "Pawtucket",
  "state": "RI",
  "zip": "02861"
}, {
  "city": "Pawtucket",
  "state": "RI",
  "zip": "02862"
}, {
  "city": "Central Falls",
  "state": "RI",
  "zip": "02863"
}, {
  "city": "Cumberland",
  "state": "RI",
  "zip": "02864"
}, {
  "city": "Lincoln",
  "state": "RI",
  "zip": "02865"
}, {
  "city": "Portsmouth",
  "state": "RI",
  "zip": "02871"
}, {
  "city": "Portsmouth",
  "state": "RI",
  "zip": "02872"
}, {
  "city": "Hopkinton",
  "state": "RI",
  "zip": "02873"
}, {
  "city": "North Kingstown",
  "state": "RI",
  "zip": "02874"
}, {
  "city": "Richmond",
  "state": "RI",
  "zip": "02875"
}, {
  "city": "North Smithfield",
  "state": "RI",
  "zip": "02876"
}, {
  "city": "North Kingstown",
  "state": "RI",
  "zip": "02877"
}, {
  "city": "Tiverton",
  "state": "RI",
  "zip": "02878"
}, {
  "city": "South Kingstown",
  "state": "RI",
  "zip": "02879"
}, {
  "city": "South Kingstown",
  "state": "RI",
  "zip": "02880"
}, {
  "city": "South Kingstown",
  "state": "RI",
  "zip": "02881"
}, {
  "city": "Narragansett",
  "state": "RI",
  "zip": "02882"
}, {
  "city": "South Kingstown",
  "state": "RI",
  "zip": "02883"
}, {
  "city": "Warren",
  "state": "RI",
  "zip": "02885"
}, {
  "city": "Warwick",
  "state": "RI",
  "zip": "02886"
}, {
  "city": "Warwick",
  "state": "RI",
  "zip": "02887"
}, {
  "city": "Warwick",
  "state": "RI",
  "zip": "02888"
}, {
  "city": "Warwick",
  "state": "RI",
  "zip": "02889"
}, {
  "city": "Westerly",
  "state": "RI",
  "zip": "02891"
}, {
  "city": "South Kingstown",
  "state": "RI",
  "zip": "02892"
}, {
  "city": "West Warwick",
  "state": "RI",
  "zip": "02893"
}, {
  "city": "Richmond",
  "state": "RI",
  "zip": "02894"
}, {
  "city": "Woonsocket",
  "state": "RI",
  "zip": "02895"
}, {
  "city": "North Smithfield",
  "state": "RI",
  "zip": "02896"
}, {
  "city": "Richmond",
  "state": "RI",
  "zip": "02898"
}, {
  "city": "Providence",
  "state": "RI",
  "zip": "02901"
}, {
  "city": "Providence",
  "state": "RI",
  "zip": "02902"
}, {
  "city": "Providence",
  "state": "RI",
  "zip": "02903"
}, {
  "city": "Providence",
  "state": "RI",
  "zip": "02904"
}, {
  "city": "Providence",
  "state": "RI",
  "zip": "02905"
}, {
  "city": "Providence",
  "state": "RI",
  "zip": "02906"
}, {
  "city": "Providence",
  "state": "RI",
  "zip": "02907"
}, {
  "city": "Providence",
  "state": "RI",
  "zip": "02908"
}, {
  "city": "Providence",
  "state": "RI",
  "zip": "02909"
}, {
  "city": "Cranston",
  "state": "RI",
  "zip": "02910"
}, {
  "city": "North Providence",
  "state": "RI",
  "zip": "02911"
}, {
  "city": "Providence",
  "state": "RI",
  "zip": "02912"
}, {
  "city": "East Providence",
  "state": "RI",
  "zip": "02914"
}, {
  "city": "East Providence",
  "state": "RI",
  "zip": "02915"
}, {
  "city": "East Providence",
  "state": "RI",
  "zip": "02916"
}, {
  "city": "Smithfield",
  "state": "RI",
  "zip": "02917"
}, {
  "city": "Providence",
  "state": "RI",
  "zip": "02918"
}, {
  "city": "Johnston",
  "state": "RI",
  "zip": "02919"
}, {
  "city": "Cranston",
  "state": "RI",
  "zip": "02920"
}, {
  "city": "Cranston",
  "state": "RI",
  "zip": "02921"
}, {
  "city": "Providence",
  "state": "RI",
  "zip": "02940"
}]

export const StateInitials: string[] = Object.keys(StateIDs).filter(i => isNaN(+i));
